import React from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonGroup, ErrorPage } from '@uhg-uicl/ui-core/dist';
import history from 'utils/history';
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({ hasError: true });
    // You can also log the error to an error reporting service
    // eslint-disable-next-line no-console
    console.log(error, info);
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    if (hasError) {
      return (
        <ErrorPage
          title="Something went wrong"
          message="Oops! Something went wrong. If this issue persists, please contact a system administrator"
          footer={() => (
            <ButtonGroup className="footer">
              <Button
                buttonType="emphasized"
                name="Reload Page"
                onClick={() => {
                  window.location.reload(false);
                }}
                size="medium"
                type="button"
                dataTestId="go-back-home-btn"
              />
            </ButtonGroup>
          )}
        />
      );
    }
    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
};

export default ErrorBoundary;
